module.exports = __webpack_public_path__ + "static/media/blog2_3.2075e8f4.webp";